<template>
  <teleport to="#app">
    <div ref="modal" class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false">
      <div
        class="modal-dialog modal-fullscreen"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <slot name="title" />
            </h5>
            <button v-if="closable" type="button" class="btn-close" @click="hide" />
          </div>
          <div class="modal-body">
            <slot name="body" />
          </div>
          <div class="modal-footer">
            <slot name="footer" />
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import modal from '@/modules/core/mixins/modal';

export default {
  mixins: [modal],
  expose: ['show', 'hide'],
  methods: {
    show() { this.show_(); },
    hide() { this.hide_(); },
  },
};
</script>
